import styled from 'styled-components'

type Props = {
  active: boolean
  userImage: string
}

const ComponentStyled = styled.div<Props>`
  position: relative;
  height: 376px;

  &:before {
    content: '';
    position: absolute;
    width: 10px;
    height: 110%;
    background-color: ${({ active, theme }) => (active ? theme.colors.brown3 : theme.colors.secondaries.opacity80)};
    left: 50%;
    transform: translateX(-50%);
    top: -60px;
    border: 2px solid ${({ theme }) => theme.colors.brown3};

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
      height: 90%;
    }

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
      height: 80%;
      top: 50px;
    }
  }

  .main-box {
    position: relative;
    top: -50px;
    background-color: ${({ active, theme }) => (active ? theme.colors.brown3 : theme.colors.secondaries.opacity80)};
    border: 2px solid ${({ theme }) => theme.colors.brown3};
    border-radius: 7px;
    padding: 5px 10px;
    display: flex;
    justify-content: space-between;
    min-width: 200px;
    max-width: 100%;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
      min-width: 300px;
    }

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
      top: 60px;
      flex-direction: column;
      align-items: center;
      padding: 10px;
      min-width: 110px;
    }

    .wish-info {
      text-align: right;
      border-right: 1px solid ${({ theme }) => theme.colors.brown3};
      padding: 10px 0;
      padding-right: 16px;

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        width: 100%;
        padding: 0 0 10px;
        border-right: none;
        border-bottom: 1px solid ${({ theme }) => theme.colors.brown3};
        text-align: center;
      }

      .total {
        font-family: 'Cabin';
        font-weight: 600;
        font-size: 18px;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.black};
      }

      .wishes {
        font-family: 'Cabin';
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
        color: ${({ theme }) => theme.colors.black};
        text-transform: uppercase;
      }
    }

    .seed-info {
      margin-left: 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        width: 100%;
        padding: 10px 0 0;
        margin: 0;
        text-align: center;
      }

      .seed-type {
        font-family: 'Playfair Display';
        font-weight: 900;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0.01em;
        color: ${({ theme }) => theme.colors.black2};
      }

      .time {
        font-family: 'Playfair Display';
        font-weight: 900;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0.01em;
        color: ${({ theme }) => theme.colors.red};
      }
    }
  }
`

export default ComponentStyled
